export default {

    DASHBOARD: 'DASHBOARD',
    CONTACT: 'CONTACT',
    PRODUCT_MINI: 'PRODUCT_MINI',
    PRODUCT_LITE: 'PRODUCT_LITE',
    SET_PRODUCT: 'SET_PRODUCT',
    SHOP_MINI: 'SHOP_MINI',
    SHOP_LITE: 'SHOP_LITE',
    STORE: 'STORE',
    SALES_SETTING_MINI: 'SALES_SETTING_MINI',
    SALES_SETTING_LITE: 'SALES_SETTING_LITE',
    STOCK_MINI: 'STOCK_MINI',
    STOCK_LITE: 'STOCK_LITE',
    STATISTIC_MINI: 'STATISTIC_MINI',
    STATISTIC_LITE: 'STATISTIC_LITE',
    POS: 'POS',
    //STOCK_ARTICLE: 'STOCK_ARTICLE',
    //SHOP: 'SHOP',
    STATE_STOCK: 'STATE_STOCK',
    BUNDLE: 'BUNDLE'

}
